import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Register Admin
export const registerAdmin = createAsyncThunk(
  "admin/register",
  async (adminData, { rejectWithValue }) => {
    try {
      const res = await axios.post("https://api.aweioio.com/api/admin/register", adminData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// Login Admin
export const loginAdmin = createAsyncThunk(
  "admin/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const res = await axios.post("https://api.aweioio.com/api/admin/login", credentials);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    admin: JSON.parse(localStorage.getItem("admin")) || null,  // Initialize from localStorage
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.admin = null;
      localStorage.removeItem("admin");  // Remove admin info from localStorage on logout
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload;
        localStorage.setItem("admin", JSON.stringify(action.payload));  // Store in localStorage
      })
      .addCase(registerAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload;
        localStorage.setItem("admin", JSON.stringify(action.payload));  // Store in localStorage
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export const { logout } = adminSlice.actions;
export default adminSlice.reducer;
